import React, { useState } from "react";
import { Grid, TextField } from "@mui/material";
import moment from "moment/moment";

import { addReposoAsync } from "../../../../api/Nomina";
import { getToken } from "../../../../api/Account";
import { useAviso } from "../../../../components/base";
import {
  CampoFecha,
  DialogoFormulario,
  fechaCambiada,
  useEnvio,
  useEscritura,
} from "../comunes";

const AddReposo = ({ id, setShowModal, reload, setReload }) => {
  const [desde, setDesde] = useState(new Date());
  const [hasta, setHasta] = useState(new Date());
  const [motivo, setMotivo] = useState("");
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Las reglas de siempre y en el mismo orden: rango correcto, no más de 3 días y motivo.
  // (El texto del segundo error aclara lo mismo que la regla: de 4 días en adelante es un subsidio.)
  const errores = {};
  if (moment(desde).isAfter(moment(hasta))) {
    errores.hasta = "La fecha final no puede ser anterior a la inicial";
  } else if (moment(hasta).diff(moment(desde), "days") > 2) {
    errores.hasta = "El reposo no puede ser de más de 3 días. Para 4 días o más, registra un subsidio.";
  }
  if (motivo.length === 0) errores.motivo = "Ingrese un motivo";

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (Object.keys(errores).length > 0) return;

      const data = {
        employeeId: parseInt(id),
        motivo,
        desde: moment(desde).format("YYYY-MM-DD"),
        hasta: moment(hasta).format("YYYY-MM-DD"),
      };

      const ok = await escribir(
        () => addReposoAsync(token, data),
        "No se pudo agregar el reposo"
      );
      if (!ok) return;
      aviso.exito("Reposo agregado");
      setReload(!reload);
      setShowModal(false);
    });

  const mostrar = intentado ? errores : {};

  return (
    <DialogoFormulario
      titulo="Agregar reposo"
      onCerrar={() => setShowModal(false)}
      hayCambios={motivo !== "" || fechaCambiada(desde) || fechaCambiada(hasta)}
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Agregar reposo"
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Desde"
            value={desde}
            onChange={(newValue) => setDesde(newValue)}
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Hasta"
            value={hasta}
            onChange={(newValue) => setHasta(newValue)}
            error={mostrar.hasta}
            ayuda="Hasta 3 días. Desde 4 días es un subsidio."
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label="Motivo"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value.toLocaleUpperCase())}
            error={Boolean(mostrar.motivo)}
            helperText={mostrar.motivo || " "}
            disabled={guardando}
            inputProps={{ autoComplete: "off" }}
          />
        </Grid>
      </Grid>
    </DialogoFormulario>
  );
};

export default AddReposo;
